import type {
  DocumentPickerResponse,
  DocumentPickerItem,
  DocumentPickerFolder,
} from './documentsPicker.types'

export function adaptDocumentsApiToPickerResponse(
  apiData: any,
  folderPath: any[] | null,
  rootFolderId: number,
): DocumentPickerResponse {
  const items: DocumentPickerItem[] = (apiData?.data ?? []).map((c: any) => ({
    id: c.id,
    type: c.type === 'folder' ? 'folder' : 'file',
    name: c.name ?? c.basename,
    basename: c.basename,
    numbering: c.numbering ?? null,
  }))

  const pagination = apiData?.pagination ?? {}
  const pageZeroBased = pagination.page ?? 0
  const pageSize = pagination.pageSize ?? 25
  const total = pagination.itemCount ?? items.length

  // Root breadcrumb (always present)
  const root: DocumentPickerFolder = {
    id: rootFolderId,
    name: 'Documents',
    numbering: null,
  }

  const apiBreadcrumb: DocumentPickerFolder[] = (folderPath ?? []).map((b: any) => ({
    id: b.id,
    name: b.name ?? b.basename,
    numbering: b.numbering ?? null,
  }))

  const safeBreadcrumb: DocumentPickerFolder[] = [root, ...apiBreadcrumb]

  return {
    currentFolder: safeBreadcrumb.at(-1) ?? root,
    breadcrumb: safeBreadcrumb,
    page: {
      items,
      total,
      page: pageZeroBased + 1,
      pageSize,
    },
  }
}
